export default __webpack_public_path__ + "static/media/img_9.0cfceba7.jpg";